import createOptInOutTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/optInOutFlow/factory";
import createWebsitesTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/website/factory";
import createWidgetsTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/widgets/factory";
import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";
import type { track as TrackFunction } from "pro-features/components/WithTrack/src/context";

import createContactsTrackingService from "./contacts/factory";
import createOverviewTrackingService from "./overview/factory";
import createSignalsEventsTrackingService from "./signals-events/factory";

export default function createCompanyAnalysisCompanyTrackingService(track: TrackFunction) {
    return {
        overview: createOverviewTrackingService(track),
        signalEvents: createSignalsEventsTrackingService(track),
        contacts: createContactsTrackingService(track),
        widgets: createWidgetsTrackingService(track),
        website: createWebsitesTrackingService(track),
        optInOutFlow: createOptInOutTrackingService(track),
        trackCompanyTabClick: (tabName: string, companyName: string) => {
            track("data sections", "click", `select tab/${tabName}/${companyName}`);
        },
        trackWebsiteTabClick: (tabName: string, domain: string) => {
            track("website analysis", "click", `select tab/${tabName}/${domain}`);
        },
        trackPrepareForMeetingButtonClick: (companyName: string) => {
            track("company analysis", "click", `prepare for a meeting button/${companyName}`);
        },
        trackBreadcrumbsBackClick: () => {
            track("breadcrumbs", "click", `back to gate page`);
        },
        trackBreadcrumbsCompanyClick: () => {
            track("breadcrumbs", "click", `change company`);
        },
        trackBreadcrumbsWebsiteClick: () => {
            track("breadcrumbs", "click", `change regional`);
        },
        trackBreadcrumbsCompanySelect: () => {
            track("breadcrumbs", "click", `company selected`);
        },
        trackBreadcrumbsWebsiteSelect: () => {
            track("breadcrumbs", "click", `regional selected`);
        },
        trackRevealedStatusFilter(revealStatus: string[]) {
            const event = createTrackingEventName("reveal status", revealStatus.join(","));

            track("contacts options", "click", event);
        },
        trackLeadPriorityClick(priority: string) {
            track("Table", "click", `Priority/${priority}`);
        },
    };
}
